import { Box, Text } from "@/components/display/display-primitives";
import type { FeedItem } from "@/lib/display-feed";
import { resolveAssetUrl, getToken } from "@/lib/api";

interface PhotoSlideProps {
  item: FeedItem;
  isActive: boolean;
}

export function PhotoSlide({ item, isActive }: PhotoSlideProps) {
  const imageUrl = resolveAssetUrl(typeof item.data.image_url === "string" ? item.data.image_url : "", getToken());
  const caption = typeof item.data.caption === "string" ? item.data.caption : "";
  const authorName = typeof item.data.author_name === "string" ? item.data.author_name : "";

  return (
    <Box
      style={{
        width: "100%",
        height: "100%",
        position: "absolute",
        inset: 0,
        opacity: isActive ? 1 : 0,
        transition: "opacity 1.2s ease-in-out",
        backgroundColor: "#000",
      }}
    >
      {/* Photo principale */}
      <img
        src={imageUrl}
        alt={caption || "Photo"}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "contain",
          display: "block",
        }}
      />

      {/* Légende flottante en bas si présente */}
      {(caption || authorName) && (
        <Box
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            padding: "clamp(0.75rem, 2vw, 1.5rem) clamp(1rem, 3vw, 2.5rem)",
            background: "linear-gradient(to top, rgba(0,0,0,0.75) 0%, transparent 100%)",
          }}
        >
          {caption && (
            <Text
              as="p"
              style={{
                fontSize: "clamp(0.9rem, 2vw, 1.4rem)",
                color: "rgba(255,255,255,0.9)",
                fontWeight: 300,
                letterSpacing: "0.02em",
              }}
            >
              {caption}
            </Text>
          )}
          {authorName && (
            <Text
              as="p"
              style={{
                fontSize: "clamp(0.75rem, 1.5vw, 1.1rem)",
                color: "rgba(255,255,255,0.55)",
                marginTop: "0.2rem",
              }}
            >
              {authorName}
            </Text>
          )}
        </Box>
      )}
    </Box>
  );
}
